
import { createContext } from "react";

const PercentageContext = createContext();

export default PercentageContext;